<template>
  <div class="lang-switcher">
    <button
      ref="pemicuRef"
      type="button"
      class="lang-switcher__trigger"
      :aria-label="$t('language.change')"
      :aria-expanded="terbuka"
      aria-haspopup="menu"
      @click.stop="alihkan"
    >
      <i class="bi bi-translate" aria-hidden="true"></i>
      <span class="lang-switcher__code">{{ current.toUpperCase() }}</span>
    </button>

    <!--
      Menu dipindahkan ke <body>: di dalam header ia terpotong oleh
      backdrop-filter, di dalam footer ia terbuka ke bawah dan keluar layar.
      Lihat catatan lengkap di useMenuMengambang.js.
    -->
    <Teleport to="body">
      <transition name="popover">
        <div v-if="terbuka" ref="menuRef" class="lang-switcher__menu" role="menu" :style="gaya" @click.stop>
        <p class="lang-switcher__label">{{ $t('language.label') }}</p>

        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="lang-switcher__option"
          :class="{ 'is-active': current === option.value }"
          role="menuitemradio"
          :aria-checked="current === option.value"
          @click="choose(option.value)"
        >
            <span class="lang-switcher__flag" aria-hidden="true">{{ option.flag }}</span>
            <span>{{ option.label }}</span>
            <i v-if="current === option.value" class="bi bi-check2 ms-auto" aria-hidden="true"></i>
          </button>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import { setLocale } from '@/locales';
import { useMenuMengambang } from '@/composables/useMenuMengambang';

export default {
  name: 'LanguageSwitcher',

  setup() {
    return useMenuMengambang({ lebarMinimal: 220 });
  },

  data() {
    return {
      options: [
        { value: 'id', label: 'Bahasa Indonesia', flag: '🇮🇩' },
        { value: 'en', label: 'English', flag: '🇬🇧' },
      ],
    };
  },

  computed: {
    current() {
      return this.$i18n.locale;
    },
  },

  methods: {
    // Klik-luar, Escape, gulir, dan ubah-ukuran ditangani useMenuMengambang.
    choose(value) {
      setLocale(value);
      this.tutup();
    },
  },
};
</script>

<style scoped>
.lang-switcher { display: inline-flex; }

.lang-switcher__trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 40px;
  padding-inline: var(--space-3);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-secondary);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

.lang-switcher__trigger:hover {
  background-color: var(--bg-hover);
  color: var(--text-primary);
}

.lang-switcher__code {
  font-size: var(--text-xs);
  letter-spacing: 0.04em;
}

/*
 * Posisi disetel dari JavaScript sebagai gaya inline oleh
 * useMenuMengambang. Tidak ada top/right di sini: menyisakan `right: 0`
 * sementara JS memasang `left` akan meregangkan menu selebar layar.
 */
.lang-switcher__menu {
  position: fixed;
  z-index: calc(var(--z-modal) + 10); /* di atas laci menu HP (--z-overlay) */
  min-width: 220px;
  padding: var(--space-2);
  background-color: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.lang-switcher__label {
  margin: 0;
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}

.lang-switcher__option {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text-primary);
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  text-align: left;
  transition: background-color var(--transition-fast);
}

.lang-switcher__option:hover { background-color: var(--bg-hover); }

.lang-switcher__option.is-active {
  color: var(--text-brand);
  font-weight: 600;
}

.lang-switcher__flag { font-size: 1.1rem; line-height: 1; }

.popover-enter-active,
.popover-leave-active {
  transition: opacity var(--transition-fast), transform var(--transition-fast);
}

.popover-enter-from,
.popover-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
